import "flatpickr/dist/flatpickr.css";

import * as yup from "yup";

import flatpickr from "flatpickr";

const reservationTypes = {
	site: 1,
	accommodation: 3,
};

const elements = {
	reservationType: document.querySelectorAll('input[name="reservation_type"]'),
	quickBookerMenu: document?.getElementById("js-quick-booker-menu"),
	quickBookerToggle: document.querySelectorAll(".js-quick-booker-toggle"),
};

const validationSchema = yup.object().shape({
	arrivalDate: yup
		.string()
		.required("Arrival date is required")
		.matches(
			/^(0[1-9]|1[0-2])\/([0-2][0-9]|3[0-1])\/\d{4}$/,
			"Arrival date must be in correct format",
		),

	departureDate: yup
		.string()
		.required("Departure date is required")
		.matches(
			/^(0[1-9]|1[0-2])\/([0-2][0-9]|3[0-1])\/\d{4}$/,
			"Departure date must be in correct format",
		),
	adults: yup.number().required().min(1, "At least 1 adult is required"),
	children: yup.number().required().min(0),
	infants: yup.number().required().min(0),
	reservationType: yup.string().required(),
	caravanType: yup.string().when("reservationType", {
		is: "site",
		then: (schema) => schema.required("Caravan type is required"),
		otherwise: (schema) => schema.notRequired(),
	}),
	caravanLength: yup.string().when("reservationType", {
		is: "site",
		then: (schema) => schema.required("Caravan length is required"),
		otherwise: (schema) => schema.notRequired(),
	}),
});

Array.from(document.querySelectorAll(".js-quick-booker")).forEach(
	async (booker) => {
		booker
			.querySelector("button[type=submit]")
			?.addEventListener("click", async (e) => {
				e.preventDefault();

				const data = {
					arrivalDate: booker.querySelector('input[name="arrival_date"]').value,
					departureDate: booker.querySelector('input[name="departure_date"]')
						.value,
					adults: booker.querySelector('input[name="adults"]').value,
					children: booker.querySelector('input[name="children"]').value,
					infants: booker.querySelector('input[name="infants"]').value,
					reservationType: booker.querySelector(
						'input[name="reservation_type"]:checked',
					)?.value,
					caravanType: booker.querySelector(
						".js-site-inputs select[name=caravan_type]",
					)?.value,
					caravanLength: booker.querySelector(
						".js-site-inputs select[name=caravan_length]",
					)?.value,
				};

				try {
					await validationSchema.validate(data, { abortEarly: false });
					const url = generateRmsUrl(data);
					window.open(url, "_blank");
				} catch (err) {
					if (err.inner && err.inner.length > 0) {
						const messages = err.inner.map((e) => e.message);
						showAlert(messages);
					} else {
						showAlert(["An unexpected validation error occurred."]);
					}
				}
			});
	},
);

function formatDateNow(date) {
	const pad = (n) => String(n).padStart(2, "0");
	return (
		date.getFullYear().toString() +
		pad(date.getMonth() + 1) +
		pad(date.getDate()) +
		pad(date.getHours()) +
		pad(date.getMinutes()) +
		pad(date.getSeconds())
	);
}

function generateRmsUrl(data) {
	const now = new Date();
	const dateNow = formatDateNow(now);

	const reservationType =
		data?.reservationType === "site"
			? reservationTypes?.site
			: reservationTypes?.accommodation;

	const additionalParams =
		data?.reservationType === "site"
			? `&T=${data?.caravanType}&L=${data?.caravanLength}`
			: "";

	const baseUrl = `https://ibe12.rmscloud.com/8C23B82151A83567/1?A=${data?.arrivalDate}&D=${data?.departureDate}&Dn=${dateNow}&Rt=${reservationType}&Ad=${data?.adults}&C=${data?.children}&I=${data?.infants}${additionalParams}&X=0&Z=0#!/rooms#%2Frooms`;
	return baseUrl;
}

function showAlert(messages = []) {
	const alertBox = document.querySelector(".js-alert");
	const alertMessage = alertBox.querySelector(".js-alert-message");

	// Clear previous errors
	alertMessage.innerHTML = "";

	// Inject each message as an <li>
	messages.forEach((msg) => {
		const li = document.createElement("li");
		li.textContent = msg;
		alertMessage.appendChild(li);
	});

	alertBox.classList.remove("hidden");
}

elements?.reservationType?.forEach((input) => {
	input.addEventListener("change", function () {
		const fieldset = this.closest("fieldset");
		const container = fieldset?.parentElement;
		const siteInputs = container?.querySelector(".js-site-inputs");

		if (siteInputs) {
			const isSite = this.value === "site";
			siteInputs.setAttribute("aria-expanded", isSite ? "true" : "false");
		}
	});
});

flatpickr("input.flatpickr", {
	enableTime: false,
	altInput: true,
	altFormat: "D J M Y",
	dateFormat: "m/d/Y",
	minDate: new Date(),
});

document
	.querySelectorAll(".js-button-plus, .js-button-minus")
	.forEach((button) => {
		button.addEventListener("click", () => {
			const input = button.parentElement.querySelector("input[type='number']");
			if (!input) return;

			let currentValue = parseInt(input.value, 10) || 0;

			if (button.classList.contains("js-button-plus")) {
				input.value = currentValue + 1;
			} else if (button.classList.contains("js-button-minus")) {
				input.value = Math.max(0, currentValue - 1); // prevent going below 0
			}

			input.dispatchEvent(new Event("change")); // useful if listening for changes
		});
	});

Array.from(elements.quickBookerToggle).map((toggle) => {
	toggle.addEventListener("click", () => {
		elements?.quickBookerMenu.setAttribute(
			"aria-expanded",
			elements?.quickBookerMenu.getAttribute("aria-expanded") === "true"
				? "false"
				: "true",
		);
	});
});
